import { useEffect, useMemo, useState } from "react";
import ReactTable from 'react-table';
import { AddUpdateRoleModal, BackButton, BadgeComponent, Breadcrumbs, ButtonComponent, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { PlusSvg, VerticalDotsSvg } from "../../assets/svgs";
import { useDispatch, useSelector } from "react-redux";
import { providerInstitutionConstant, statusConstant, statusOptions } from "../../constants/user-constants";
import { getAllRoles, postAddUpdateRole } from "../../redux/slices/roles-slice";
import { toast } from "react-toastify";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { Menus } from "../../constants/menus-constant";
import { useLocation } from "react-router";

const Roles = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { institutions } = useSelector((state) => state.institutionsListReducer);
    const { loading, rolesData, pagination } = useSelector((state) => state.rolesReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };
    const initialOrderBy = {
        sortColumn: "createdDateTime",
        isAsce: false,
    };
    const initialSearch = {
        code: '',
        descr: '',
        institution: '',
        roleStatus: '',
    };

    const initialForm = {
        // code: '',
        descr: '',
        roleStatus: statusConstant?.activeValue,
        institution: user?.institution?.value === providerInstitutionConstant?.value ? '' : user?.institution?.value,
        permissions: [],
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const [form, setForm] = useState(initialForm);

    const defaultParams = { pagination: states.pagination, orderBy: states.orderBy, search: states.search };

    const getAllRolesData = (updatedParams) => {
        if (user && updatedParams) {
            dispatch(getAllRoles({ user, ...updatedParams }));
        }
    };

    // const handleReload = () => {
    //     getAllRolesData(defaultParams);
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getAllRolesData(params);
    };

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target
        if (name === 'institution') {
            setForm((old) => ({ ...old, [name]: ['checkbox', 'radio'].includes(type) ? checked : value, permissions: [] }));
        } else {
            setForm((old) => ({ ...old, [name]: ['checkbox', 'radio'].includes(type) ? checked : value }));
        }
    };

    const handleCheckboxTreeChange = (value, checked) => {
        setForm((old) => ({
            ...old,
            permissions: checked
                ? [...old.permissions, value]
                : old.permissions.filter((v) => v !== value),
        }));
    };

    // const handleChangeFilters = (e) => {
    //     const { name, value, type, checked } = e.target
    //     setStates((old) => ({
    //         ...old,
    //         search: ({
    //             ...old.search,
    //             [name]: ['checkbox', 'radio'].includes(type) ? checked : value
    //         })
    //     }));
    // };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    // const handleToggleFilters = () => {
    //     setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: !states.isFiltersOpen }));
    // };

    const handleModalOpen = (e) => {
        if (['view', 'edit'].includes(e)) {
            setForm({
                code: states?.selected?.code,
                // code: states?.selected?.code?.split('-')[0],
                descr: states?.selected?.descr,
                roleStatus: states?.selected?.roleStatus?.value,
                institution: states?.selected?.institution?.value,
                permissions: states?.selected?.permissions?.map(p => p?.id),
                reason: states?.selected?.reason,
            });

            if (e === 'view') {
                setStates((old) => ({ ...old, isView: true, isModalOpen: true }));
            } else if (e === 'edit') {
                setStates((old) => ({ ...old, isUpdate: true, isModalOpen: true }));
            }
        } else {
            setStates((old) => ({ ...old, isModalOpen: true }));
            setForm(initialForm);
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null, isUpdate: false, isView: false }));
    };

    const handleFormSubmit = () => {
        if (user && form) {
            const updatedForm = {
                ...form,
                // code: `${form.code}-${form.institution}`,
            }

            if (form.permissions.length === 0) {
                toast.error('Role cannot be created without any permission');
            } else {
                dispatch(postAddUpdateRole({ user, body: updatedForm, update: states.isUpdate })).then((action) => {
                    if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                        handleModalClose();
                        getAllRolesData(defaultParams);
                    }
                });
            }
        }
    };

    // const handleFiltersSubmit = (e) => {
    //     e.preventDefault();
    //     const params = {
    //         ...defaultParams,
    //         search: states.search,
    //         pagination: initialPagination,
    //     };
    //     getAllRolesData(params);
    // };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        const params = {
            ...defaultParams,
            search: searchToUse,
            pagination: initialPagination,
        };
        getAllRolesData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search, [key]: value || '' };
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

    const actions = [
        { label: 'View', action: () => handleModalOpen('view') },
        { label: 'Edit', action: () => handleModalOpen('edit') },
    ];

    useEffect(() => {
        getAllRolesData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (rolesData && Array.isArray(rolesData)) {
            setStates((old) => ({ ...old, data: rolesData, pagination: pagination }));
        }
    }, [rolesData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const searchFields = [
    //     {
    //         label: 'Code',
    //         type: 'number',
    //         placeholder: 'Search by code',
    //         name: 'code',
    //         value: states.search.code,
    //     },
    //     {
    //         label: 'Name',
    //         type: 'text',
    //         placeholder: 'Search by name',
    //         name: 'descr',
    //         value: states.search.descr,
    //     },
    //     {
    //         label: 'Status',
    //         type: 'select',
    //         options: statusOptions,
    //         name: 'roleStatus',
    //         value: states.search.roleStatus,
    //     },
    //     {
    //         label: 'Institution',
    //         type: 'select',
    //         options: institutions,
    //         name: 'institution',
    //         value: states.search.institution,
    //     },
    //     {
    //         type: 'action',
    //         actions: [
    //             { label: 'Cancel', icon: CrossSvg, type: 'button', outline: true, action: handleToggleFilters },
    //             { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
    //         ],
    //     }
    // ];

    // TABLE COLUMNS SETUP AS PER DATA
    // const columns = [
    //     { field: 'code', headerName: 'Code', width: 70 },
    //     { field: 'descr', headerName: 'Description', width: 120 },
    //     {
    //         field: 'institution', headerName: 'Institution', width: 120,
    //         valueGetter: (row) => row?.institution && row?.institution?.label,
    //     },
    //     {
    //         field: 'roleStatus',
    //         headerName: 'Status',
    //         width: 100,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.roleStatus &&
    //                         <BadgeComponent
    //                             label={row?.roleStatus?.label}
    //                             type={{
    //                                 [statusConstant.activeValue]: 'success',
    //                                 [statusConstant.inactiveValue]: 'warning',
    //                                 [statusConstant.lockedValue]: 'error'
    //                             }[row?.roleStatus?.value] || 'default'}
    //                         />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.roleStatus?.label,
    //     },
    //     { field: 'createdDateTime', headerName: 'Created At', width: 170, align: 'center' },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];

    const columns = useMemo(() => [
        {
            accessor: 'createdDateTime', Header: 'Created At', minWidth: 240,
            style: {
                textAlign: 'center'
            },
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'code', Header: 'Code', minWidth: 240,
            style: {
                textAlign: 'center'
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="code"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('code', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('code', value, true);
                        }
                    }}
                    placeholder="Search by code"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'descr', Header: 'Name', minWidth: 240,
            style: {
                textAlign: 'center'
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="descr"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('descr', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('descr', value, true);
                        }
                    }}
                    placeholder="Search by Name"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'institution', Header: 'Institution', minWidth: 200,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row.original.institution?.label || '-',
            Filter: ({ filter, onChange }) => (
                <select
                    name="institution"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('institution', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        institutions.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            // filterMethod: (filter, row) => {
            //     if (!filter.value) return true;
            //     return row.original.institution?.value === filter.value;
            // },
            sortable: false,
            filterable: isProvider ? true : false,
        },
        {
            accessor: 'roleStatus',
            Header: 'Status',
            minWidth: 150,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.roleStatus &&
                            <BadgeComponent
                                label={row?.original?.roleStatus?.label}
                                type={{
                                    [statusConstant.activeValue]: 'success',
                                    [statusConstant.inactiveValue]: 'warning',
                                    [statusConstant.lockedValue]: 'error'
                                }[row?.original?.roleStatus?.value] || 'default'}
                            />
                        }
                    </>
                )
            },
            Filter: ({ filter, onChange }) => (
                <select
                    name="roleStatus"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('roleStatus', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        statusOptions.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            sortable: false,
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected, institutions]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Roles</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>

                <div className="right">
                    <ButtonComponent icon={PlusSvg} label="Add role" size="small" disabled={loading} onClick={handleModalOpen} />
                    {/* <IconButtonComponent icon={FilterSvg} outline onClick={handleToggleFilters} /> */}
                </div>
            </AuthPageHead>

            {/* FILTER */}
            {/* {
                searchFields && searchFields.length > 0 &&
                <FiltersComponent open={states.isFiltersOpen} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} />
            } */}

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/* {
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            } */}

            {/* PAGE CONTENT */}
            {
                // !loading && states.data && states.data.length > 0 &&
                <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={true}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen &&
                <AddUpdateRoleModal data={form} label={`${states.isUpdate ? 'Update' : states.isView ? 'View' : 'Add'} Role`} viewOnly={states.isView} update={states.isUpdate} close={handleModalClose} handleFormChange={handleFormChange} handleCheckboxTreeChange={handleCheckboxTreeChange} handleFormSubmit={handleFormSubmit} slide />
            }
        </AuthPageContainer>
    );
};

export default Roles;